import { useQuery } from '@tanstack/react-query';
import { homeAPI } from '../api/homeAPI';

type SettingsPayload = {
  mindbox?: boolean;
  data?: {
    mindbox?: boolean;
  };
};

const getMindboxEnabled = (payload?: SettingsPayload) => {
  if (typeof payload?.mindbox === 'boolean') {
    return payload.mindbox;
  }

  if (typeof payload?.data?.mindbox === 'boolean') {
    return payload.data.mindbox;
  }

  return true;
};

export const useGetSettings = () => {
  const { data = { isMindboxEnabled: true }, isLoading } = useQuery({
    queryKey: ['settings'],
    queryFn: async () => await homeAPI.getSettings(),
    select: response => ({
      isMindboxEnabled: getMindboxEnabled(response.data),
    }),
  });

  return {
    ...data,
    isLoading,
  };
};
